import { DailyControlModel } from '@/models/dailyControl'
import { EmployeeWithTime, TaskSheetItem, WorkShifTTask } from '@/models/taskSheet'
import { createHtmlEmploteeInfo, dateLibs, msToHours, subtractTime } from '.'

export const totalDailyControl = (dailyWorks: DailyControlModel[]) => {
  let total = 0
  dailyWorks.forEach(d => {
    total += d.total
  })
  return total
}

export const createItemToTaskSheet = (employeeWithTime: EmployeeWithTime, workType: number, isSupport = false, $day: number|null = null): TaskSheetItem => {
  const workShift = employeeWithTime.employee.assignment.work_shift
  const dayInWorkShift = workShift.week_days_list?.find(work_day => work_day.key === $day)
  let timeLunch = 0
  let workShifTask: WorkShifTTask = {
    workShiftId: 0,
    isCumulative: false,
    isNocturnal: false,
    checkin_time: '',
    checkout_time: '',
    lunch_time_entry: '',
    lunch_time_ends: ''
  }
  if (workShift) {
    timeLunch = msToHours(subtractTime(workShift.lunch_time_entry, workShift.lunch_time_ends))
    workShifTask = {
      workShiftId: Number(workShift.id),
      isCumulative: workShift.is_cumulative,
      isNocturnal: workShift.is_nocturnal,
      checkin_time: workShift.checkin_time,
      checkout_time: workShift.checkout_time,
      lunch_time_entry: workShift.lunch_time_entry,
      lunch_time_ends: workShift.lunch_time_ends
    }
  }
  const timeIn = employeeWithTime.timeInDevice ? employeeWithTime.timeInDevice : (employeeWithTime.employee.assignment.fixed_dialing ? employeeWithTime.employee.assignment.work_shift.checkin_time : '')
  const timeOut = employeeWithTime.timeOutDevice ? employeeWithTime.timeOutDevice : (employeeWithTime.employee.assignment.fixed_dialing ? employeeWithTime.employee.assignment.work_shift.checkout_time : '')
  const timeInFinal = dayInWorkShift && employeeWithTime.permisssionControl.length <= 0 ? dateLibs.getOnlyHourAndMinute(timeIn) : ''
  const timeOutFinal = dayInWorkShift && employeeWithTime.permisssionControl.length <= 0 ? dateLibs.getOnlyHourAndMinute(timeOut) : ''
  const hasPermission = employeeWithTime.permisssionControl.length > 0
  // If the employee absent then check lunch like OFF
  let lunchCheck = false
  if (employeeWithTime.employee.assignment.lunch) {
    if (!hasPermission) {
      if (timeInFinal && timeOutFinal) {
        lunchCheck = true
      }
    }
  }

  return {
    employeeId: employeeWithTime.employee.id ?? 0,
    employeeBaseSalary: employeeWithTime.employee.finance.base_salary ?? 0,
    employeeText: createHtmlEmploteeInfo(employeeWithTime.employee),
    timeInDevice: dateLibs.getOnlyHourAndMinute(employeeWithTime.timeInDevice || ''),
    timeOutDevice: dateLibs.getOnlyHourAndMinute(employeeWithTime.timeOutDevice || ''),
    timeIn: timeInFinal,
    timeOut: timeOutFinal,
    timeWorkingTotal: 0,
    timeTotal: 0,
    timeTotalReal: 0,
    timeExtra25: 0,
    timeExtra35: 0,
    timeTotalN: 0,
    timeExtra25N: 0,
    timeExtra35N: 0,
    timeHed: 0,
    workShift: workShifTask,
    timeLunch: timeLunch,
    cumulativeHoursDay: 0,
    cumulativeHoursOld: employeeWithTime.timeCumulative,
    condition: 0,
    workType: workType,
    observations: '',
    viewWorkDescription: false,
    dailyControls: employeeWithTime.dailyControls.map(daily => {
      return {
        id: daily.id,
        workDescriptionId: daily.work_description_id,
        name: daily.workDescription.name,
        price: daily.price,
        amount: daily.amount,
        total: daily.total
      }
    }),
    amounts: totalDailyControl(employeeWithTime.dailyControls),
    hasPermission: hasPermission,
    permissions: employeeWithTime.permisssionControl,
    isSupport: isSupport,
    lunch: lunchCheck,
    ajeno: false,
    feriado: false,
    lunch_rate: employeeWithTime.employee.assignment.lunch_rate,
    lunch_rate_id: employeeWithTime.employee.assignment.lunch_rate_id,
    amount_lunch: 1,
    price_lunch: employeeWithTime.employee.assignment.lunch_rate?.price ?? 0
  }
}
